import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";
import { grey } from "@material-ui/core/colors";
import Typography from "../components/Typography";
import Button from "../components/Button";

const APP_STORE_URL = "https://apps.apple.com/us/app/dubslack/id1591330134";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      backgroundColor: grey[200],
    },
    container: {
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(10),
    },
    title: {
      marginBottom: theme.spacing(6),
    },
    step: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: theme.spacing(4),
    },
    badge: {
      flexShrink: 0,
      width: 40,
      height: 40,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      fontFamily: "'Roboto Condensed', sans-serif",
      fontWeight: theme.typography.fontWeightMedium,
      marginRight: theme.spacing(2),
    },
    image: {
      width: "100%",
      maxWidth: 280,
      height: "auto",
    },
    imageWrapper: {
      display: "flex",
      justifyContent: "center",
    },
  });

const steps: React.ReactNode[] = [
  "Download the Dubslack mobile app.",
  "Open the app and tap 'Add Account'.",
  <React.Fragment>
    Sign in with Slack and authorize <strong>Dubstatus</strong> to access
    your workspace.
  </React.Fragment>,
  "Repeat 'Add Account' for additional workspaces (optional).",
  "Update your Slack status from the Dubslack app and it is automatically synchronized across every connected workspace.",
];

function HowItWorks(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Typography variant="h4" marked="center" align="center" className={classes.title}>
          How It Works
        </Typography>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={7}>
            {steps.map((step, index) => (
              <div className={classes.step} key={index}>
                <span className={classes.badge}>{index + 1}</span>
                <Typography variant="body1">{step}</Typography>
              </div>
            ))}
            <Box mt={6}>
              <Button
                color="secondary"
                variant="contained"
                size="large"
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download on the App Store
              </Button>
              {/* Re-enable once Dubslack is relisted on the Play Store:
              <Button
                color="secondary"
                variant="contained"
                size="large"
                href="https://play.google.com/store/apps/details?id=com.dubslack"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: 16 }}
              >
                Get it on Google Play
              </Button>
              */}
            </Box>
          </Grid>
          <Hidden smDown>
            <Grid item md={5} className={classes.imageWrapper}>
              <img
                className={classes.image}
                src="/iphone-with-screenshot-account.png"
                alt="Adding a Slack account in the Dubslack app"
              />
            </Grid>
          </Hidden>
        </Grid>
      </Container>
    </section>
  );
}

export default withStyles(styles)(HowItWorks);
